<template>
<!--  <nav>-->
<!--    <router-link to="/">Home</router-link> |-->
<!--    <router-link to="/about">About</router-link>-->
<!--  </nav>-->

<!--  <shareComponent />-->

  <router-view v-if="routerViewVisible"/>

</template>

<script setup>
  // import shareComponent from "@/components/shopopee/share/shareComponent"

  import {ref, provide, nextTick, toRef, onBeforeMount} from "vue";
  import {useUserinfo} from "@/stores/userinfo";
  import {useAdmininfo} from "@/stores/adminInfo";
  import myUtil from "@/util/util";

  const userInfoRef = toRef(useUserinfo())
  const adminInfoRef = toRef(useAdmininfo())
  const routerViewVisible = ref(true)

  provide('reload', () => {
    routerViewVisible.value = false

    // nextTick(() => {
    //     routerViewVisible.value = true
    // })

    setTimeout(() => {
        routerViewVisible.value = true
    }, 200)

  })

  onBeforeMount(() => {
      if (myUtil.isNotEmpty(adminInfoRef.value.login)){
          myUtil.loadAdminMemberInfo(userInfoRef.value, adminInfoRef.value)
      }
  })

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

html {
  scroll-behavior: smooth;
  overflow-x: hidden;
}

body {
  /*margin-top: 0;*/
  /*margin-bottom: 0;*/
  margin: 0;
}

.a-text:-webkit-any-link {
    color: unset;
    cursor: pointer;
    text-decoration: none;
}

.a-text {
    color: unset;
    cursor: pointer;
    text-decoration: none;
}

ul {
    list-style: none;
    padding-left: 0;
}
</style>
